module.exports = __webpack_public_path__ + "static/media/sf_logo.e4eb2369.svg";